import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import MainHQ from "@/pages/MainHQ";
import Auth from "@/pages/Auth";
import EvidenceRoom from "@/pages/EvidenceRoom";
import BrainScan from "@/pages/BrainScan";
import HallOfFame from "@/pages/HallOfFame";
import Profile from "@/pages/Profile";
import KidsAcademy from "@/pages/KidsAcademy";
import ParentCenter from "@/pages/ParentCenter";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainHQ />} />
            <Route path="/enter" element={<Auth />} />
            <Route path="/evidence" element={<EvidenceRoom />} />
            <Route path="/brain-scan" element={<BrainScan />} />
            <Route path="/hall-of-fame" element={<HallOfFame />} />
            <Route path="/academy" element={<KidsAcademy />} />
            <Route path="/parents" element={<ParentCenter />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#17100B",
              border: "1px solid rgba(245,158,11,0.3)",
              color: "#E6D5B8",
              fontFamily: "'Special Elite', monospace",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
